<ng-container *sm-has-env-flag="'auroraV1'">
    <aurora-header auroraAppHeader [view]="'Work'">
        <account-search slot="main"></account-search>
        <div slot="main" class="title_bar--item title_bar--new">
            <new-business-button *sm-has-permission="TENANT_PERMISSIONS.Base_Work_Accounts_AddAccounts"></new-business-button>
        </div>
        <user-task-timer slot="actions"></user-task-timer>
        <ikc-button slot="actions" />
        <sm-notification-icon-button slot="actions"></sm-notification-icon-button>
        @if (authService.getAreaKey()) {
        <div slot="actions" class="main-menu-dropdown" (click)="$event.stopPropagation()">
            <aurora-icon-button
                id="mainMenuButton"
                class="main-menu-button"
                variant="ghost"
                size="xlarge"
                icon="more-vertical"
                label="Main menu"
                (click)="toggleMainMenu($event)">
            </aurora-icon-button>
            @if (isMainMenuOpen) {
            <div class="main-menu-dropdown-panel">
                <sm-main-menu [view]="'Work'" (itemSelected)="isMainMenuOpen = false"></sm-main-menu>
            </div>
            }
        </div>
        }
    </aurora-header>
</ng-container>

<ng-container *sm-has-not-env-flag="'auroraV1'">
    <unity-header [view]="'Work'">
        <ng-container main >
            <account-search></account-search>
            <div class="title_bar--item title_bar--new">
                <new-business-button *sm-has-permission="TENANT_PERMISSIONS.Base_Work_Accounts_AddAccounts"></new-business-button>
            </div>
        </ng-container>
        <ng-container right>
            <div class="unity-header--item">
                <user-task-timer></user-task-timer>
            </div>
            <div class="unity-header-item">
                <ikc-button />
            </div>
            <div class="unity-header-item">
                <sm-notification-icon-button></sm-notification-icon-button>
            </div>
            @if (syncStatus) {
            <div class="unity-header-item">
                <sm-sync-status [status]="syncStatus" [placement]="'bottom-right'"></sm-sync-status>
            </div>
            }
        </ng-container>
    </unity-header>
</ng-container>

<main>
    <router-outlet></router-outlet>
    <unity-loading-indicator *ngIf="loading" [display]="UnityLoadingIndicatorDisplayEnum.Overlay"></unity-loading-indicator>
</main>
